import { api } from "./apiClient";

export const terminalQrService = {
  current: async () => (await api.get("/terminal/qr")).data,
  validate: async (token) => (await api.get(`/terminal/qr/validate/${token}`)).data,
};
